import React from "react";
import TextView from "../../TextView";
import { TextContainer } from "./styles";
import CustomLoader from "../../../sharedcomponents/CustomLoader";
import { ASSETS } from "../../../utils/config";

export const PrivacyPolicyAPI = ({ data, isLoading, error }) => {
  if (isLoading) {
    return (
      <TextContainer
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <CustomLoader />
      </TextContainer>
    );
  }

  if (error) {
    return (
      <TextContainer>
        <TextView variant="largeText">
          Error loading privacy policy: {error?.message}
        </TextView>
      </TextContainer>
    );
  }

  const privacyPolicyData = data?.data?.results?.find(
    (item) => item.slug === "privacy_policy"
  );

  if (!privacyPolicyData) {
    return (
      <TextContainer>
        <TextView variant="largeText">
          Privacy policy content not found.
        </TextView>
      </TextContainer>
    );
  }

  let modifiedHtml = privacyPolicyData.body;

  const targetTags = ["strong", "h1", "h2", "h3", "h4", "h5", "h6"];
  const newImportantStyles = `margin-bottom: 0; font-family: 'DM Sans' !important; font-weight: bold !important; font-size: 24px !important; text-align: left !important;`;

  // Step 1: Strip existing inline style attributes from target tags (and span)
  const stripStyleRegex = new RegExp(
    `<(span|${targetTags.join("|")})([^>]*?)\s+style="[^"]*"([^>]*)>`,
    "gi"
  );
  modifiedHtml = modifiedHtml.replace(stripStyleRegex, "<$1$2$3>");

  // Step 2: Apply new important styles to target tags
  const applyStyleRegex = new RegExp(`<(strong|h[1-6])([^>]*?)>`, "gi");
  modifiedHtml = modifiedHtml.replace(
    applyStyleRegex,
    `<$1 style="${newImportantStyles}"$2>`
  );

  // Step 3: Inject the image and flex container around the very first actual HTML tag
  const firstMeaningfulTagRegex = /<([a-z][a-z0-9]*)\b[^>]*>/i;
  const matchFirstMeaningful = modifiedHtml.match(firstMeaningfulTagRegex);

  if (matchFirstMeaningful) {
    const fullFirstTag = matchFirstMeaningful[0];
    const imageHtml = `<img src="${ASSETS.Insurance}" alt="iYuga Privacy Policy Icon" style="width: 36px; height: 36px;" />`;
    const replacement = `<div style="display: flex; align-items: center; gap: 10px;">${imageHtml}${fullFirstTag}`;
    modifiedHtml = modifiedHtml.replace(fullFirstTag, replacement);

    const firstTagName = matchFirstMeaningful[1];
    modifiedHtml = modifiedHtml.replace(
      new RegExp(`<\\/${firstTagName}>`),
      `</${firstTagName}></div>`
    );
  }

  return (
    <TextContainer>
      <div
        dangerouslySetInnerHTML={{
          __html: modifiedHtml,
        }}
      />
    </TextContainer>
  );
};
